import BasicValidation from 'components/components/common/BasicValidation';
import mergeErrors from 'components/helpers/mergeErrors';
import TransHelper from 'components/common/translations/TransHelper';

export default class ReservationUpdateValidation extends BasicValidation {
  constructor(reservationUpdate,locale) {
    super();
    this.reservationUpdate = reservationUpdate;
    this.passegnerCountError = TransHelper.translate(locale, 'content.errors.passengerCount');
    this.childrenCountError = TransHelper.translate(locale, 'content.errors.childrenSeats');
  }

  passengersValid() {
    return this.adultsValid() && this.childrenValid();
  }

  adultsValid() {
    return this.reservationUpdate.adults > 0;
  }

  childrenValid() {
    if (this.reservationUpdate.children > 0) {
      var total = 0;
      for (var key in this.reservationUpdate.kidsSafety) {
        total += this.reservationUpdate.kidsSafety[key];
      }
      return total === this.reservationUpdate.children;
    } else {
      return true;
    }
  }

  addressValid() {
    if (this.isEmptyValue(this.reservationUpdate.address.error)) {
      var addressObj = this.reservationUpdate.address;
      if(this.isEmptyValue(addressObj.selectedObject)){
        return false;
      }

      if (this.reservationUpdate.address.selectedObject.g) {
        //google street
        if (this.isEmptyValue(addressObj.postcode) ||
          this.isEmptyValue(addressObj.lat) ||
          this.isEmptyValue(addressObj.lng)) {
          return false;
        } else {
          return true;
        }
      } else {
        //bus stop
        return !this.isEmptyValue(addressObj.selectedObject.value);
      }
    } else {
      return false;
    }
  }

  getFormErrors() {
    var hash = {};
    if (!this.adultsValid()) {
      hash['passengers'] = this.passegnerCountError;
    }
    if (!this.childrenValid()) {
      hash['children'] = this.childrenCountError;
    }
    if (!this.addressValid()) {
      hash['address'] = this.reservationUpdate.address.error;
    }
    return mergeErrors(hash);
  }

  isValidForm() {
    return this.passengersValid() && this.addressValid();
  }
}
